import React from 'react'
import { Link } from 'react-router-dom'
import 'css/components/return-to-dashboard.css'

export const ReturnToDashboard = () => {
    return (
        <div className="return-to-dashboard-container">
            <Link to="/dashboard" className="return-to-dashboard-link">
                &lt; Return to Teacher Dashboard
            </Link>
        </div>
    )
}